
function TimesSVG() {
  return (
    <svg width="27" height="29" viewBox="0 0 27 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="24.549" y1="26.3375" x2="2.47668" y2="2.92594" stroke="#2ABDBB" strokeWidth="5.25532"/>
      <line x1="2.47676" y1="26.1738" x2="24.5491" y2="2.7622" stroke="#2ABDBB" strokeWidth="5.25532"/>
    </svg>
  )
}

function TimesMiniSVG() {
  return (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 2.3257L17.6743 0L10 7.67431L2.3257 0L0 2.3257L7.67431 10L0 17.6743L2.3257 20L10 12.3257L17.6743 20L20 17.6743L12.3257 10L20 2.3257Z" fill="white"/>
    </svg>
  )
}

function TimesOffCenterSVG() {
  return (
    <svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="0.353553" y1="1.14645" x2="8.35355" y2="9.14645" stroke="white"/>
      <line x1="8.35355" y1="1.85355" x2="0.353553" y2="9.85355" stroke="white"/>
    </svg>
  )
}



export { TimesSVG, TimesMiniSVG, TimesOffCenterSVG }
